import React from "react";
import { Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddMultipleGridList from "../../components/AddMultipleGridList";
import { useRuleResourceContext } from "../../contexts/RuleResourceContext";
import ReadMoreLess from "../../components/ReadMoreLess";
import { useAppTranslation } from "../../hooks/useAppTranslation";
const CrossFieldValidations = ({
  crossFieldValidations,
  setCrossFieldValidations,
  isViewOnly,
  errors,
  setErrors,
}: any) => {
  const [expanded, setExpanded] = React.useState<string | false>();
  const { t } = useAppTranslation();
  const { availColumns } = useRuleResourceContext();

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  return (
    <>
      <div
        className={`accordion-panel text-box-card compact-text-box-card no-radius bottom-radius bg-white ${
          isViewOnly ? "" : "table-filter-bg"
        }`}
        style={{ marginBottom: "0" }}
      >
        {isViewOnly ? (
          <Box>
            {crossFieldValidations?.length > 0 ? (
              <Box className="MuiCollapse-vertical ">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th style={{ width: "30%" }}>
                        {t("crossFieldValidations.tableHeaders.name")}
                      </th>
                      <th>
                        {t("crossFieldValidations.tableHeaders.sqlQuery")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {crossFieldValidations?.map((item: any, index: any) => {
                      return (
                        <tr key={index}>
                          <td>{item?.name}</td>
                          <td>
                            {item?.sql_query?.length > 100 ? (
                              <ReadMoreLess
                                data={item.sql_query}
                                charLimit={100}
                              />
                            ) : (
                              item?.sql_query || ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Box>
            ) : (
              <p>{t("crossFieldValidations.noData")}</p>
            )}
          </Box>
        ) : (
          <>
            <AddMultipleGridList
              gridValue={crossFieldValidations}
              setGridValue={setCrossFieldValidations}
              isViewOnly={isViewOnly}
              buttonName="Adhoc Query"
              errors={errors}
              setErrors={setErrors}
              sampleQuery={`SELECT * FROM <TABLE_NAME> WHERE [${(() => {
                // Extract first column for sample query (backward compatibility)
                const flatColumns = Array.isArray(availColumns)
                  ? availColumns
                  : (availColumns as any)?.flatColumns || [];
                return flatColumns.length > 0 ? flatColumns[0] : "";
              })()}] IS NOT NULL`}
            />
          </>
        )}
      </div>
    </>
  );
};

export default CrossFieldValidations;
